module.exports = __webpack_public_path__ + "static/media/HairRemoval01.233e16ac.jpeg";